import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-751686fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "faq-page" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "faq-page__heading" }, "سوالات متداول", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "faq-page__title" }, " مهمترین سوالات متداول درباره خرید و فروش تتر ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_windows_10_loading = _resolveComponent("windows-10-loading")!
  const _component_faq_item = _resolveComponent("faq-item")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.breakpoints.isMobile && 'main-container my-4'])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        (_ctx.status === 'loading')
          ? (_openBlock(), _createBlock(_component_windows_10_loading, {
              key: 0,
              class: "position-relative mb-5 pb-5"
            }))
          : (_ctx.status === 'success')
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.response?.items, (faq, index) => {
                return (_openBlock(), _createBlock(_component_faq_item, { key: index }, {
                  title: _withCtx(() => [
                    _createTextVNode(_toDisplayString(faq.title), 1)
                  ]),
                  content: _withCtx(() => [
                    _createTextVNode(_toDisplayString(faq.text), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}